import React from "react";

interface Stylist {
  name: string;
  email?: string;
  thisMonth: number;
  total: number;
}

interface TopStylistsProps {
  stylists: Stylist[];
  currencySymbol?: string;
}

const TopStylists = ({ stylists, currencySymbol = "£" }: TopStylistsProps) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-lg font-semibold text-[#402B69] mb-4">
        Top Stylists
      </h2>
      <div className="space-y-4">
        {stylists.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 opacity-60">
            <p className="text-gray-500 font-medium">No stylist data found</p>
          </div>
        ) : (
          stylists.map((s, i) => (
            <div
              key={i}
              className="flex items-center justify-between p-4 rounded-lg bg-[#F9F9F9] hover:bg-[#EDE3F7] transition"
            >
              <div>
                <p className="font-semibold text-[#1E1E1E]">{s.name}</p>
                {s.email && <p className="text-sm text-gray-500">{s.email}</p>}
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-500">This Month</p>
                <p className="font-semibold text-[#885ABB]">{currencySymbol}{s.thisMonth}</p>
                <p className="text-xs text-gray-400">Total {currencySymbol}{s.total}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopStylists;
